/**
 * The phase a fight is on, in the player's language.
 *
 * Explicit per phase rather than "action, else preparation": a fight opens on
 * ESTABLISHMENT now (everyone at the position is pulled in and picks a side),
 * and the old two-way fallback labelled it "Preparation" — telling the player
 * to move during a phase in which nothing can move.
 */
export function fightPhaseLabel(phase, t) {
  const normalized = String(phase || '').toLowerCase();
  if (normalized === 'action') return t('fightHud.phaseAction');
  if (normalized === 'establishment') return t('fightHud.phaseEstablishment');
  return t('fightHud.phasePreparation');
}
